import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    root: {
      marginBottom: Spacings.s64,
      display: 'flex',
      flexDirection: 'column',
    },
    skeletonTitle: {
      height: 36,
      width: '60%',
      marginBottom: Spacings.s12,
    },
    skeletonDescription: {
      height: 24,
      width: '80%',
      marginBottom: Spacings.s12,
    },
  },
  {
    name: 'top-banenr-skeleton',
  },
);

export default useStyles;
